
import CryptoJS from 'crypto-js'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Multiselect from 'vue-multiselect'
import Pagination from './../../../../../shared/components/pagination'
import Loader from './../../../../../shared/components/loader'
import TripServices from './../../../../services/firstAndLastmilemanagement.service'
export default {
  name: 'CreateRouteMapping',
  components: {
    CryptoJS,
    Pagination,
    Loader,
    Multiselect 
  },
  props: ['parentObj'],
  data: function () {
    return {
      routeNameSearch:null,
      AssignedList: [],
      RouteList:[],
      AssignedSR: null,
      SelectedRoutes:[],
      isLoading: false,
      disbaleClientName: false,
      AssignedListForUpdate:[],
      UpdateSR:null,
      UpdateRoutes:[],
      selectedSR: [{ id: "", label: "" }],
      selectedname:[],
      RouteNameSearch:[{id:"",label:""}],
      username:"",
      routeNameErr: '',
      srUserErr: '',
      hubnamelist:[],
      hubname: null,
      hubID:null,

    };
  },
  computed: {},
  async mounted () {
    await this.getHubList();
    if (this.parentObj.action == 'update') {
      this.isLoading = true
      this.selectedrouteID = this.parentObj.AssignedSR.id;
      this.selectedSR[0].id = this.parentObj.AssignedSR.userid;
      this.selectedSR[0].label = `${this.parentObj.AssignedSR.username} (${this.parentObj.AssignedSR.userid})`;
      this.selectedname=this.parentObj.RouteName;
      this.isLoading = false;
      this.hubID = this.parentObj.hubID;
      this.hubnamelist.forEach(item=> {
        if (item.value == this.hubID) {
          this.hubname = {"value": this.hubID, "text": item.text}
        }
      })
      this.getSRListingRouteMapping();
      this.getRouteListing();
    }
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.defaultHubID = userdetail.hubID[0];
    this.useremail = this.parentObj.useremail;
    this.username=userdetail.email;
  },
  methods: {
    async getSRListingRouteMapping() {
      try {
        this.isLoading=true;
        this.AssignedList= [];
        let InputPayload = {
          HubId: [this.hubID]
        };
        let result = await TripServices.getSRListRouteMapping(InputPayload);
        if(result.data.code == 200){
        let SRList = result.data.data;
        for (var i = 0; i < SRList.length; i++) {
          this.AssignedList.push({
            'usertype':SRList[i].emptype,
            'id': SRList[i].userid,
            'label': `${SRList[i].srname} (${SRList[i].userid})`,
            'username': SRList[i].srname ,
            '$isDisabled':SRList[i].disable,
          });
        }
      } else if(result.data.code == 409) {

      }else{
        this.$alert(result.data.message, "", "error");
      }
      this.isLoading=false;
      } catch (err) {
        this.isLoading=false;
        console.log(err);
      }
    },
    async updateroutemapping(input) {
      try {
        if(this.checkErr()){
          return false
        }
        let payload = { id: 100, routeid: [6] };
        
        if (this.selectedrouteID) {
          payload.id = this.selectedrouteID
        }
        if(this.selectedname)
        {
          let List=[]
          for (var i = 0; i < this.selectedname.length; i++) {
            List.push(this.selectedname[i].id);
          }
          payload.routeid = List
        }
        payload.lastmodifiedby=this.username;
        let result = await TripServices.updateRouteMapping(payload);
        if(result.data.code == 200){
          this.$alert(result.data.message, "", "success");
          this. showRouteMappingList()
        }else{
          this.$alert(result.data.message, "", "error");
        }
      } catch (error) {
        this.isLoading = false;
        this.$alert("error",error);
      }
    },
    async getRouteListing() {
      try {
        this.isLoading=true;
        this.RouteList=[];
        let InputPayload = {
          HubId: [this.hubID]
        };
        let result = await TripServices.getRouteList(InputPayload);
        if(result.data.code == 200){
        let RouteList = result.data.data;
        for (var i = 0; i < RouteList.length; i++) {
          this.RouteList.push({
            'id': RouteList[i].id,
            'label': RouteList[i].routename ,
            '$isDisabled':RouteList[i].disable,
          });
        }
        }else{
         this.$alert(result.data.message, "", "error");
        }
        this.isLoading=false;
      } catch (err) {
        this.isLoading=false;
        console.log(err);
      }
    },
  
    async saveRouteMapping(){
      try{
        if(this.checkErr()){
          return false
        }
        let List=[];
        let userId=null;
        let userName=null;
        let userType=null;
        let routeId=null;
        if(this.AssignedSR)
        {
          userId=this.AssignedSR.id
          userName= this.AssignedSR.username
          userType =this.AssignedSR.usertype
        }
        if(this.routeNameSearch)
        {
          for (var i = 0; i < this.routeNameSearch.length; i++) {
            List.push(this.routeNameSearch[i].id);
          }
          routeId=List.length<=0?null:List;
        }
        let input = {
          "userid":userId,
          "username" : userName ,
          "usertype":userType,
          "useremail":this.parentObj.useremail,
          "hubid":this.hubID,
          "createdby":this.parentObj.useremail,
          "lastmodifiedby":this.username,
          "routeid" : routeId,
          "status":0,
        }
          let result = await TripServices.saveRouteMapping(input);
          if(result.data.code == 200){
            this.$alert(result.data.message, "", "success");
            this. showRouteMappingList()
          }else{
            this.$alert(result.data.message, "", "error");
          }    
      } catch(err){
        console.log(err);
      }
    },
    checkErr(){
      let err = 0
      if(this.parentObj.action == 'create')
      {
        if(!this.AssignedSR){
          this.srUserErr = 'Please Select User/SR'
          err = 1
        }else{
          this.srUserErr = ''
        }
        if(!this.routeNameSearch){
            this.routeNameErr = 'Please Select Route Name'
            err = 1
          }else{
            if(this.routeNameSearch.length<=0)
            {
              this.routeNameErr = 'Please Select Route Name'
              err = 1
            }
            else{
            this.routeNameErr = ''
            } 
          }
      }
      else if(this.parentObj.action == 'update')
      {
        if(this.selectedname.length<=0)
        {
          this.routeNameErr = 'Please Select Route Name'
          err = 1
        }
        else{
        this.routeNameErr = ''
        } 
      }
      return err
    },
    showRouteMappingList() {
      this.$emit("goBackToParent")
    },
    async getHubList() {
      try {
        this.isLoading=true;
        let input = {}
        let tempArr = [];
        let result = await TripServices.GetHublist(input);
        let HubList = result.data.data.data;
        for (var i = 0; i < HubList.length; i++) {
          tempArr.push({
            'value': HubList[i].HubID,
            'text': HubList[i].HubName
          });
        }
        this.hubnamelist = tempArr
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    async selectHub(data) {
      this.selectedHub = data;
      this.hubID = data.value;
      this.AssignedSR= null;
      this.AssignedList= [];
      this.routeNameSearch=null;
      this.RouteList=[];
      await this.getSRListingRouteMapping();
      await this.getRouteListing();
    },

  },
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/Autoallocation/RouteMapping/CreateRouteMapping/CreateRouteMapping.component.js